import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, Outlet, Link, useLocation } from "react-router-dom";
// import { SubMenu } from "tamtam-components";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import moment from "moment";
import {
  setAuthUser,
  setAuthToken,
  setExpiresIn,
  setTokenCreatedAt,
  setAuthLoggedAs,
  setAuthLoggedAsPost,
  setAuthSpaceAs,
  fetchAuthUser,
  setLanguage,
  setNavCommunity,
  setNavCommunityId,
  fetchNavCommunity,
  setAuthLoggedIsAdmin,
  setManagerNotification,
  setSynchronisationNotification,
  setHeader,
  setAuthCollaborator,
} from "../../store";
import {
  getAuthInfosFromCookie,
  getLocalStorageAuth,
  setLocalStorageAuth,
  authHasExpired,
  getCookie,
  logout,
  getUserCurrentNavCommunity,
  parsePreference,
} from "../../utils";
import {
  getClientCredential,
  getManagerNotification,
  getCollaboratorsTimeSheetNotification,
  getCollaborator,
} from "../../api";
import {
  APP_ENV,
  TTP_POWERTEAM_URL,
  TTP_HOME_URL,
  URL_HASH_KEY,
} from "../../config";
import _ from "../../i18n";

import Menu from "./Menu";
import SubMenu from "./SubMenu";
import { useQuery } from "react-query";

const decryptWithAES = (ciphertext) => {
  var encryptMethod = "AES-256-CBC";
  var aesNumber = encryptMethod.match(/\d+/)[0];
  var encryptMethodLength = parseInt(aesNumber);

  var json = JSON.parse(
    CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(ciphertext))
  );

  var salt = CryptoJS.enc.Hex.parse(json.salt);
  var iv = CryptoJS.enc.Hex.parse(json.iv);

  var encrypted = json.ciphertext;

  var iterations = parseInt(json.iterations);
  if (iterations <= 0) {
    iterations = 999;
  }
  var encryptMethodLength = encryptMethodLength / 4;
  var hashKey = CryptoJS.PBKDF2(URL_HASH_KEY, salt, {
    hasher: CryptoJS.algo.SHA512,
    keySize: encryptMethodLength / 8,
    iterations: iterations,
  });

  var decrypted = CryptoJS.AES.decrypt(encrypted, hashKey, {
    mode: CryptoJS.mode.CBC,
    iv: iv,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
};

const Layout = () => {
  const auth = useSelector((state) => state.auth);
  const location = useLocation();
  const { loggedAs, spaceAs } = auth;
  const language = useSelector((state) => state.params.language);
  const showHeader = useSelector((state) => state.params.header);
  const [synchroNotificationFetched, setSynchroNotificationFetched] =
    useState(false);
  const dispatch = useDispatch();
  let { lang } = useParams();
  const navigate = useNavigate();
  const [preferences, setPreferences] = useState(null);

  const handleAuthUser = (user) => {
    dispatch(setAuthToken(user.token));
    dispatch(setExpiresIn(user.expiresIn));
    dispatch(setTokenCreatedAt(user.createdAt));
    dispatch(fetchAuthUser(user));
    // dispatch(fetchFiduciary());
  };

  useEffect(() => {
    var query = location.search.substring(1);
    var vars = query.split("&");
    const searchParams = new URLSearchParams(location.search);

    let queryToken = "";
    let userId = "";
    let organisationId = "";

    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] === "params") {
        const hashParams = decryptWithAES(decodeURIComponent(pair[1]));

        const tabQueryParams = hashParams.split(",");
        tabQueryParams.forEach((item) => {
          const tmp = item.split("=");
          if (tmp.length > 0) {
            if (tmp[0] === "token") {
              queryToken = tmp[1];
            } else if (tmp[0] === "userId") {
              userId = tmp[1];
            } else if (tmp[0] === "without_header") {
              dispatch(setHeader(false));
              // } else if (tmp[0] === "without_submenu") {
              //   dispatch(setSubMenu(false));
              // } else if (tmp[0] === "without_backnav") {
              //   dispatch(setBackNav(false));
              // } else if (tmp[0] === "current_app") {
              //   dispatch(setCurrentApp(tmp[1]));
            } else if (tmp[0] === "organization_id") {
              dispatch(setNavCommunityId(tmp[1]));
            }
          }
        });
      }
    }

    let authInfos = getAuthInfosFromCookie();

    if (["fr", "en", "nl"].includes(lang)) {
      dispatch(setLanguage(lang));
      // cookieCutter.set(`ttp_lng_${APP_ENV}`, lng);
    } else {
      const lng = localStorage.getItem("lng") || "fr";
      dispatch(setLanguage(lng));
    }

    const auth = getLocalStorageAuth();

    if (queryToken && userId) {
      handleAuthUser({
        token: queryToken,
        createdAt: Date.now(),
        expiresIn: 10000,
        id: userId,
      });
    } else if (
      auth &&
      auth.user &&
      authInfos &&
      authInfos.token === auth.token
    ) {
      let collaboratorListSynchroList = [];
      if (auth.navCommunity) {
        let day = moment().date();
        let month = moment().month() + 1;
        collaboratorListSynchroList = getCollaboratorsTimeSheetNotification(
          [
            [
              "01-01",
              (month < 10 ? "0" : "") +
                month +
                "-" +
                (day < 10 ? "0" : "") +
                day,
            ],
          ],
          auth.navCommunity.id,
          auth.token
        );
      }

      dispatch(setAuthToken(auth.token));
      dispatch(setExpiresIn(auth.expiresIn));
      dispatch(setTokenCreatedAt(auth.createdAt));
      dispatch(setAuthUser(auth.user));
      dispatch(setAuthLoggedAs(auth.loggedAs));
      dispatch(setAuthLoggedAsPost(auth.loggedAsPost));
      if (collaboratorListSynchroList.length > 0) {
        collaboratorListSynchroList.then((result) => {
          const data = result.data.data;
          dispatch(setSynchronisationNotification(data));
        });
      }

      if (
        auth.user.role &&
        ["LEGAL_REPRESENTATIVE", "MANAGER"].includes(auth.user.role.type) &&
        auth.user.role.typeStatus !== "FOLDER"
      ) {
        dispatch(setAuthLoggedIsAdmin(true));
      }
      if (auth.navCommunity) {
        dispatch(setNavCommunity(auth.navCommunity));
      }

      const lng = localStorage.getItem("lng");
      if (!lng || lng.length === 0) {
        dispatch(setLanguage(auth.user.language));
      }

      if (!auth.navCommunity) {
        dispatch(fetchNavCommunity());
      }
    } else if (!authInfos || authHasExpired(authInfos)) {
      setLocalStorageAuth(null);
      const goto = encodeURIComponent(TTP_POWERTEAM_URL);
      window.location.assign(`${TTP_HOME_URL}?goto=${goto}`);
    } else if (authInfos) {
      handleAuthUser(authInfos);
      window.location.assign(`/`);
    } else {
      const tokenData = getClientCredential();
      if (tokenData?.responseJSON?.token) {
        const savedToken = tokenData?.responseJSON.token;
        dispatch(setAuthToken(savedToken.access_token));
        dispatch(setExpiresIn(savedToken.expiresIn));
        dispatch(setTokenCreatedAt(savedToken.createdAt));
        // dispatch(setAuthUser(auth.user));
      }
    }
  }, []);

  useEffect(() => {
    if (auth.user && !auth.navCommunity) {
      const cookieCommunity = getCookie("ttp_community_" + APP_ENV);
      if (cookieCommunity) {
        let currentNavCommunity = getUserCurrentNavCommunity(
          auth.user,
          cookieCommunity
        );
        if (currentNavCommunity) {
          dispatch(setNavCommunity(currentNavCommunity));
        } else {
          dispatch(fetchNavCommunity());
        }
      } else {
        dispatch(fetchNavCommunity());
      }
    }
    if (auth && auth.user && auth.navCommunity && !synchroNotificationFetched) {
      let day = moment().date();
      let month = moment().month() + 1;
      let collaboratorListSynchroList = getCollaboratorsTimeSheetNotification(
        [
          [
            "01-01",
            (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day,
          ],
        ],
        auth.navCommunity.id,
        auth.token
      );
      if (collaboratorListSynchroList) {
        collaboratorListSynchroList.then((result) => {
          const data = result.data.data;
          dispatch(setSynchronisationNotification(data));
        });
      }
      setSynchroNotificationFetched(true);
    }
    if (auth && auth.user && auth.navCommunity) {
      let authorizations =
        auth.navCommunity.id === 4
          ? auth.user.userOrganizations.find(
              (organization) => organization.id === auth.navCommunity.id
            ).authorisation
          : {};
      let preferencesResult = authorizations.preferences;
      setPreferences(preferencesResult);

      if (window.location.pathname === `/`) {
        if (preferencesResult) {
          if (
            preferencesResult.dashboard &&
            parsePreference(preferencesResult.dashboard).allowAccess
          ) {
            if (authorizations.role === "MANAGER") {
              navigate(`/${language}/dashboard?partner=${auth?.user?.id}`);
            } else if (
              authorizations.role === "ADMIN" ||
              authorizations.role === "SUPERADMIN"
            ) {
              navigate(`/${language}/dashboard?admin=${auth?.user?.id}`);
            } else {
              navigate(`/${language}/collaborator/dashboard`);
            }
          } else if (
            preferencesResult.clients &&
            parsePreference(preferencesResult.clients).allowAccess
          ) {
            navigate(`/${language}/clients`);
          } else {
            navigate(`/${language}/collaborators`);
          }
        }
      }
    }
    if (
      auth &&
      auth.navCommunity &&
      auth.navCommunity.id &&
      auth.user &&
      auth.user.userOrganizations.length > 0
    ) {
      let orgs = auth.user.userOrganizations.filter((org) => {
        return parseInt(org.id) === parseInt(auth.navCommunity.id);
      });
      let navCommunity = null;
      navCommunity = orgs[0] || null;
      // if (!organizationIsSet) {
      setNavCommunity(navCommunity);
      if (navCommunity) {
        setAuthLoggedAs(navCommunity.authorisation.role);
        dispatch(setAuthLoggedAs(navCommunity.authorisation.role));
        if (navCommunity.authorisation.role === "SUPERADMIN")
          dispatch(setAuthSpaceAs("SUPERADMIN"));
        else if (navCommunity.authorisation.role === "ADMIN")
          dispatch(setAuthSpaceAs("ADMIN"));
        else if (navCommunity.authorisation.role === "MANAGER")
          dispatch(setAuthSpaceAs("MANAGER"));
      } else {
        dispatch(setAuthSpaceAs("COLLABORATOR"));
      }
      // setOrganizationIsSet(true);
      // }
    }
    if (auth && auth.user && auth.navCommunity) {
      getCollaborator(
        null,
        auth.navCommunity.id,
        auth.token,
        auth.user.uid,
        auth.user?.adminisId?.split(":")[1]
      )
        .then((collaborator) => {
          dispatch(setAuthCollaborator(collaborator.data.data));
        })
        .catch((error) => {
          console.error("Error fetching collaborator:", error);
        });
    }
  }, [auth.user, auth.navCommunity]);

  useEffect(() => {
    if (auth && auth.user && auth.navCommunity) {
      let authorizations =
        auth.navCommunity.id === 4
          ? auth.user.userOrganizations.find(
              (organization) => organization.id === auth.navCommunity.id
            ).authorisation
          : {};

      if (!loggedAs) {
        navigate(`/${language}`);
      } else if (window.location.pathname === `/${language}`) {
        if (authorizations.role === "MANAGER") {
          navigate(`/${language}/dashboard?partner=${auth.user?.id}`);
        } else if (
          authorizations.role === "ADMIN" ||
          authorizations.role === "SUPERADMIN"
        ) {
          navigate(`/${language}/dashboard?admin=${auth?.user?.id}`);
        } else {
          navigate(`/${language}/collaborator/dashboard`);
        }
      }
      if (
        [
          "SUPERADMIN",
          "ADMIN",
          "PARTNER",
          "COLLABORATOR",
          "SUPERVISOR",
        ].includes(loggedAs)
      ) {
        let managerNotification = getManagerNotification(
          auth?.user?.uid,
          auth.navCommunity.id,
          auth.token,
          loggedAs
        );
        if (managerNotification) {
          managerNotification.then((result) => {
            const data = result.data.data;
            const pendingData = data.data.filter(
              (not) => not.status === "PENDING"
            );
            dispatch(
              setManagerNotification({
                ...data,
                countPending: pendingData
                  ? pendingData.length +
                    (auth.managerNotification
                      ? auth.managerNotification.countPending
                      : 0)
                  : 0,
              })
            );
          });
        }
      }
    }
    if (auth && auth.user && auth.navCommunity) {
      getCollaborator(
        null,
        auth.navCommunity.id,
        auth.token,
        auth.user.uid,
        auth.user?.adminisId?.split(":")[1]
      )
        .then((collaborator) => {
          dispatch(setAuthCollaborator(collaborator.data.data));
        })
        .catch((error) => {
          console.error("Error fetching collaborator:", error);
        });
    }
  }, [auth.user, loggedAs, language]);

  let subMenu = [];
  const roles = ["SUPERADMIN", "ADMIN", "MANAGER"];
  const hasMatchingRole = roles.includes(loggedAs) && loggedAs === spaceAs;
  if (!loggedAs) {
    subMenu = [{ community: false }];
  } else if (hasMatchingRole) {
    subMenu = [
      {
        title: _("dashboard"),
        url: `/${language}/dashboard`,
        iconUrl: "/img/icon/header/trello.svg",
        className: "hide-for-small-only",
        hasAccess:
          preferences?.dashboard &&
          parsePreference(preferences.dashboard).allowAccess,
      },
      {
        title: _("CLIENTS"),
        url: `/${language}/clients`,
        iconUrl: "/img/icon/header/folder.svg",
        community: false,
        hasAccess:
          preferences?.clients &&
          parsePreference(preferences.clients).allowAccess,
      },
      {
        title: _("COLLABORATEURS"),
        url: `/${language}/collaborators`,
        iconUrl: "/img/icon/header/user.svg",
        className: "hide-for-small-only",
        hasAccess:
          preferences?.collaborators &&
          parsePreference(preferences.collaborators).allowAccess,
      },
      {
        title: _("PRESTATIONS"),
        url: `/${language}/time-sheet`,
        iconUrl: "/img/icon/header/timer.svg",
        className: "hide-for-small-only",
        hasAccess:
          preferences?.prestations &&
          parsePreference(preferences.prestations).allowAccess,
      },
      {
        title: _("FINANCIER"),
        iconUrl: "/img/icon/header/sheet.svg",
        icon: "/img/icon/header/chevron_down.svg",
        className: "hide-for-small-only",
        hasAccess:
          preferences?.financial &&
          parsePreference(preferences.financial).allowAccess,
        subMenu: [
          {
            title: _("Table dynamique"),
            url: `/${language}/dynamicTable`,
            className: "hide-for-small-only",
            hasAccess:
              preferences?.financial &&
              parsePreference(preferences.financial).dynamicTable.allowAccess,
          },
          {
            title: _("Financial Sheet"),
            url: `/${language}/financial-sheet`,
            hasAccess:
              preferences?.financial &&
              parsePreference(preferences.financial).financialState.allowAccess,
          },
          {
            title: _("Forfait"),
            url: `/${language}/forfait`,
            hasAccess:
              preferences?.financial &&
              parsePreference(preferences.financial).forfait.allowAccess,
          },
          {
            title: _("Croissance"),
            url: `/${language}/croissance`,
            hasAccess:
              preferences?.financial &&
              parsePreference(preferences.financial)?.croissance.allowAccess,
          },
        ],
      },
      // {
      //   title: _("dynamicTable"),
      // url: `/${language}/dynamic-table`,
      //   iconUrl:
      //     "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/header/articles.svg",
      //   className: "hide-for-small-only",
      //   hasAccess: preferences && preferences.allowAccessDynamicTab === "1",
      // },

      {
        title: _("RAPPORTS"),
        url: `/${language}/reporting`,
        iconUrl: "/img/icon/header/briefcase.svg",
        className: "hide-for-small-only",
        hasAccess:
          preferences?.reporting &&
          parsePreference(preferences.reporting).allowAccess,
      },
      {
        title: _("CAPACITY PL"),
        iconUrl: "/img/icon/header/calendar_clock.svg",
        icon: "/img/icon/header/chevron_down.svg",
        className: "hide-for-small-only",
        hasAccess:
          preferences?.capacityPlanning &&
          parsePreference(preferences.capacityPlanning).allowAccess,
        subMenu: [
          {
            title: _("Synthèse"),
            url: `/${language}/capacity-planing`,
            className: "hide-for-small-only",
            hasAccess:
              preferences?.financial &&
              parsePreference(preferences.financial).dynamicTable.allowAccess,
          },
          {
            title: _("Portefeuilles"),
            url: `/${language}/portfolio`,
            className: "hide-for-small-only",
            hasAccess:
              preferences?.financial &&
              parsePreference(preferences.financial)?.croissance.allowAccess,
          },
        ],
      },
    ];
    // if (loggedAs === "MANAGER" && spaceAs === "MANAGER") {
    //   subMenu.unshift({
    //     title: _("dashboardPartner"),
    //     url: `/${language}/dashboard?user=${auth?.user?.id}`,
    //     iconUrl:
    //       "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/header/trello.svg",
    //     className: "hide-for-small-only",
    //     hasAccess:
    //       preferences && preferences.allowAccessToCollaboratorList === "1",
    //   });
    // }
    // if (preferences && preferences.allowAccessToClientList === "1") {
    //   subMenu.unshift({
    //     title: _("clients"),
    //     url: `/${language}/clients`,
    //     iconUrl:
    //       "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/team/folder.svg",
    //     community: false,
    //     hasAccess: preferences && preferences.allowAccessToClientList === "1",
    //   });
    // }
  } else {
    subMenu = [
      {
        title: _("dashboard"),
        url: `/${language}/collaborator/dashboard`,
        iconUrl: "/img/icon/header/trello.svg",
        community: false,
        hasAccess:
          preferences?.dashboard &&
          parsePreference(preferences.dashboard).allowAccess,
      },
      {
        title: _("CLIENTS"),
        url: `/${language}/clients`,
        iconUrl: "/img/icon/header/folder.svg",
        community: false,
        hasAccess:
          preferences?.clients &&
          parsePreference(preferences.clients).allowAccess,
      },
      {
        title: _("MON ESPACE"),
        url: `/${language}/user-space`,
        iconUrl: "/img/icon/header/user.svg",
        community: false,
        hasAccess:
          preferences?.collaborators &&
          parsePreference(preferences.collaborators).allowAccess,
      },
      {
        title: _("PRESTATIONS"),
        url: `/${language}/collaborator/time-sheet`,
        iconUrl: "/img/icon/header/timer.svg",
        community: false,
        hasAccess:
          preferences?.prestations &&
          parsePreference(preferences.prestations).allowAccess,
      },
      {
        title: _("FINANCIER"),
        iconUrl: "/img/icon/header/sheet.svg",
        icon: "/img/icon/header/chevron_down.svg",
        className: "hide-for-small-only",
        hasAccess:
          preferences?.financial &&
          parsePreference(preferences.financial).allowAccess,
        subMenu: [
          {
            title: _("Table dynamique"),
            url: `/${language}/dynamicTable`,
            className: "hide-for-small-only",
            hasAccess:
              preferences?.financial &&
              parsePreference(preferences.financial).dynamicTable.allowAccess,
          },
          {
            title: _("Financial Sheet"),
            url: `/${language}/financial-sheet`,
            hasAccess:
              preferences?.financial &&
              parsePreference(preferences.financial).financialState.allowAccess,
          },
          {
            title: _("Forfait"),
            url: `/${language}/forfait`,
            hasAccess:
              preferences?.financial &&
              parsePreference(preferences.financial).forfait.allowAccess,
          },
          {
            title: _("Croissance"),
            url: `/${language}/croissance`,
            hasAccess:
              preferences?.financial &&
              parsePreference(preferences.financial)?.croissance.allowAccess,
          },
        ],
      },
      {
        title: _("RAPPORTS"),
        url: `/${language}/reporting`,
        iconUrl: "/img/icon/header/briefcase.svg",
        className: "hide-for-small-only",
        hasAccess:
          preferences?.reporting &&
          parsePreference(preferences.reporting).allowAccess,
      },
    ];
    // if (preferences && preferences.allowAccessToClientList === "1") {
    //   subMenu.unshift({
    //     title: _("clients"),
    //     url: `/${language}/clients`,
    //     iconUrl:
    //       "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/team/folder.svg",
    //     community: false,
    //     hasAccess: true,
    //   });
    // }
  }
  if (
    !showHeader &&
    ["SUPERADMIN", "ADMIN", "MANAGER"].includes(loggedAs) &&
    ["SUPERADMIN", "ADMIN", "MANAGER"].includes(spaceAs)
  ) {
    subMenu.push({
      title: _("PARAMETRES"),
      iconUrl: "/img/icon/header/wrench.svg",
      icon: "/img/icon/header/chevron_down.svg",
      // iconUrl:
      //   "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/header/authors.svg",
      icon: "/img/icon/header/chevron_down.svg",
      hasAccess:
        preferences?.settings &&
        parsePreference(preferences.settings).allowAccess,
      subMenu: [
        {
          title: _("Categories"),
          url: `/${language}/category-settings`,
          // iconUrl:
          //   "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/team/folder.svg",
          community: false,
          hasAccess:
            preferences?.settings &&
            parsePreference(preferences.settings).allowAccessCategories,
        },
        {
          title: _("Task types"),
          url: `/${language}/task-types`,
          // iconUrl:
          //   "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/header/articles.svg",
          className: "hide-for-small-only",
          hasAccess:
            preferences?.settings &&
            parsePreference(preferences.settings).allowAccessTaskTypes,
        },
        {
          title: _("Collaborateurs"),
          url: `/${language}/collaborators-settings`,
          // iconUrl:
          //   "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/header/articles.svg",
          className: "hide-for-small-only",
          hasAccess:
            preferences?.settings &&
            parsePreference(preferences.settings).allowAccessCollaborators,
        },
        {
          title: _("Calendrier"),
          url: `/${language}/calendar-settings`,
          // iconUrl:
          //   "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/header/articles.svg",
          className: "hide-for-small-only",
          hasAccess:
            preferences?.settings &&
            parsePreference(preferences.settings).allowAccessCalendar,
        },
        {
          title: _("Paramétres"),
          url: `/${language}/parameter-settings`,
          // iconUrl:
          //   "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/header/articles.svg",
          className: "hide-for-small-only",
          hasAccess:
            preferences?.settings &&
            parsePreference(preferences.settings).allowAccessParameters,
        },
        {
          title: _("Utilisateurs"),
          url: `/${language}/authorizations`,
          // iconUrl:
          //   "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/header/articles.svg",
          className: "hide-for-small-only",
          hasAccess:
            preferences?.settings &&
            parsePreference(preferences.settings).allowAccessUsers,
        },
        {
          title: _("Synchronisation"),
          url: `/${language}/synchronisation-page`,
          // iconUrl:
          //   "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/header/articles.svg",
          className: "hide-for-small-only",
          hasAccess:
            preferences?.settings &&
            parsePreference(preferences.settings).allowAccessSynchronization,
        },
        {
          title: _("Modeles"),
          url: `/${language}/modeles-settings`,
          // iconUrl:
          //   "https://tamtam.s3.eu-west-1.amazonaws.com/cdn/img/icon/header/articles.svg",
          className: "hide-for-small-only",
          hasAccess:
            preferences?.settings &&
            parsePreference(preferences.settings).allowAccessModels,
        },
      ],
    });
  }
  return (
    <div className="off-canvas-wrapper">
      {auth.user && (
        <div className="off-canvas-content">
          {auth && auth.navCommunity && showHeader && (
            <Menu token={auth.token} />
          )}
          {auth.user &&
            ["COLLABORATOR", "MANAGER", "ADMIN", "SUPERADMIN"].includes(
              loggedAs
            ) && (
              <div>
                {/* <NotificationContainer /> */}
                <div
                  className={`flex-container flex-child-auto
            flex-dir-column
          `}
                >
                  <SubMenu
                    RouterLink={Link}
                    lng={language}
                    hideVertical={!showHeader}
                    menu={subMenu}
                  />
                </div>
                <Outlet />
              </div>
            )}
          {auth.user &&
            loggedAs !== "SUPERADMIN" &&
            loggedAs !== "ADMIN" &&
            loggedAs !== "MANAGER" &&
            loggedAs !== "COLLABORATOR" && (
              <div className="no_data">
                <div className="title">
                  {_(
                    "L'application Power Team n'est pas Activée pour l'organisation actuelle."
                  )}
                </div>
                <div className="subTitle">
                  {_(
                    "Pour plus d'informations sur ce produit, merci de nous consulter."
                  )}
                </div>
              </div>
            )}
        </div>
      )}
      <div className="mask hide" />
    </div>
  );
};

export default Layout;
